// extracted by mini-css-extract-plugin
export var backgroundImg = "hero-module--background-img--d0f3d";
export var basic = "hero-module--basic--12486";
export var bonus = "hero-module--bonus--d328c";
export var bonusBox = "hero-module--bonus-box--d02ec";
export var content = "hero-module--content--24299";
export var ctas = "hero-module--ctas--7c4d5";
export var description = "hero-module--description--f3942";
export var home = "hero-module--home--d37e8";
export var image = "hero-module--image--dfb2d";
export var overview = "hero-module--overview--fa585";